import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import { Partner, Distributor, Wholesale, ExportEnquiry, InternationalBuyers, GlobalMarkets, Quality, PrivateLabel } from "@/pages/B2BPages";
import { OurStory, Botanicals, Contact, Legal } from "@/pages/ContentPages";
import { Journal, JournalPost } from "@/pages/Journal";
import Admin from "@/pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/become-a-distributor" element={<Distributor />} />
          <Route path="/wholesale" element={<Wholesale />} />
          <Route path="/export-enquiry" element={<ExportEnquiry />} />
          <Route path="/export" element={<GlobalMarkets />} />
          <Route path="/international-buyers" element={<InternationalBuyers />} />
          <Route path="/global-markets" element={<GlobalMarkets />} />
          <Route path="/quality" element={<Quality />} />
          <Route path="/private-label" element={<PrivateLabel />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/botanicals" element={<Botanicals />} />
          <Route path="/journal" element={<Journal />} />
          <Route path="/journal/:slug" element={<JournalPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal/:slug" element={<Legal />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
